const actions = {
  accessHome: {
    id: 1,
    description: 'Home',
  },
  accessMyDecorated: {
    id: 2,
    description: 'Decorado - Fotos',
  },
  accessConstructionProgress: {
    id: 3,
    description: 'Acompanhe a Obra - Fotos',
  },
  accessLegalDocs: {
    id: 4,
    description: 'Documentos do Empreendimento - Doc Legais',
  },
  accessGeneralDocs: {
    id: 5,
    description: 'Documentos do Empreendimento - Doc Gerais',
  },
  accessBulletins: {
    id: 6,
    description: 'Comunicados',
  },
  accessFaq: {
    id: 7,
    description: 'FAQ',
  },
  accessToExpirePaymentSlip: {
    id: 8,
    description: 'Financeiro: boleto próx venc',
  },
  accessLatePaymentSlip: {
    id: 9,
    description: 'Financeiro: boletos em atraso',
  },
  accessFinancialIR: {
    id: 10,
    description: 'Financeiro: IR',
  },
  accessFinancialPosition: {
    id: 11,
    description: 'Financeiro: posição financeira',
  },
  login: {
    id: 12,
    description: 'Login',
  },
  forgotPassword: {
    id: 13,
    description: 'Esqueceu a senha',
  },
  firstAccess: {
    id: 14,
    description: 'Primeiro acesso',
  },
  myDecoratedTour: {
    id: 15,
    description: 'Decorado - Tour',
  },
  accessTicketDetails: {
    id: 16,
    description: 'Atendimento: acompanhar chamados',
    details: ['number'],
  },
  passwordChange: {
    id: 17,
    description: 'Alteração de cadastro - senha',
  },
  profileChange: {
    id: 18,
    description: 'Alteração de cadastro – dados cadastrais',
  },
  legalDocsDownload: {
    id: 19,
    description: 'Documentos do Empreendimento - Doc Legais download',
    details: ['title', 'attachment'],
  },
  generalDocsDownload: {
    id: 20,
    description: 'Documentos do Empreendimento - Doc Gerais download',
    details: ['title', 'attachment'],
  },
  bulletinsDownload: {
    id: 21,
    description: 'Comunicados - download',
    details: ['title', 'attachment'],
  },
  faq: {
    id: 22,
    description: 'FAQ - pergunta',
    details: ['question'],
  },
  newTicket: {
    id: 23,
    description: 'Atendimento: nova solicitação',
    details: ['number', 'summary'],
  },
  toExpirePaymentSlipDownload: {
    id: 24,
    description: 'Financeiro: boleto próx venc - download',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
    ],
  },
  latePaymentSlipDownload: {
    id: 25,
    description: 'Financeiro: boletos em atraso - download',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
      'url',
    ],
  },
  latePaymentSlipSolicitation: {
    id: 26,
    description: 'Financeiro: boletos em atraso - solicitado',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  latePaymentSlipSolicitationReady: {
    id: 27,
    description: 'Financeiro: boletos em atraso - gerado',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  ticketInteraction: {
    id: 28,
    description: 'Atendimento: acompanhar chamados – interação',
    details: ['number', 'summary', 'content', 'scheduleDate', 'reasons'],
  },
  ticketInteractionError: {
    id: 29,
    description: 'Atendimento: acompanhar chamados - interação com erro',
    details: ['number', 'content', 'attachments', 'error', 'connectionSpeed'],
  },
  accessProfile: {
    id: 30,
    description: 'Cadastro',
  },
  accessMyEnterprise: {
    id: 31,
    description: 'Meu Empreendimento',
  },
  accessTicketNew: {
    id: 32,
    description: 'Abrir Nova solicitação',
  },
  accessTicketList: {
    id: 33,
    description: 'Acompanhe suas solicitações',
  },
  passwordChangeByCode: {
    id: 34,
    description: 'Senha alterada com senha temporaria',
  },
  notificationLink: {
    id: 35,
    description: 'Notificação - link',
    details: ['id', 'type', 'info', 'link'],
  },
  bexsServerError: {
    id: 36,
    description: 'Bexs - Erro no servidor',
  },
  newTicketError: {
    id: 37,
    description: 'Atendimento: nova solicitação com erro',
    details: [
      'summary',
      'content',
      'attachmentsUrls',
      'files',
      'error',
      'connectionSpeed',
    ],
  },
  financialPositionPrint: {
    id: 38,
    description: 'Financeiro: posição financeira - impressão',
  },
  financialIRPrint: {
    id: 39,
    description: 'Financeiro: IR - impressão',
  },
  bannerActionClicked: {
    id: 40,
    description: 'Banner',
  },
  loginByAdmin: {
    id: 41,
    description: 'Login pelo Admin',
  },
  latePaymentSlipSolicitationError: {
    id: 42,
    description: 'Financeiro: boletos em atraso - erro',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  profileChangeFromHome: {
    id: 43,
    description: 'Alteração de cadastro: Home – dados cadastrais',
  },
  toExpirePaymentSlipDownloadHome: {
    id: 44,
    description: 'Financeiro: boleto próx venc: Home - download',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
    ],
  },
  toExpirePaymentSlipDownloadFinancialPosition: {
    id: 45,
    description: 'Financeiro: posição financeira - boleto próx venc - download',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
    ],
  },
  accessSelectUnit: {
    id: 46,
    description: 'Seleção de Unidades',
  },
  latePaymentSlipSolicitationExpired: {
    id: 47,
    description: 'Financeiro: boletos em atraso - expirado',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  accessTicketOmbudsman: {
    id: 48,
    description: 'Atendimento: Ouvidoria',
  },
  ombudsmanCreated: {
    id: 49,
    description: 'Atendimento: Ouvidoria - Nova Solicitação',
    details: ['originalTicket', 'number', 'summary', 'description'],
  },
  ombudsmanError: {
    id: 50,
    description: 'Atendimento: Ouvidoria - Nova Solicitação com erro',
    details: [
      'originalTicket',
      'summary',
      'content',
      'attachmentsUrls',
      'files',
      'error',
      'connectionSpeed',
    ],
  },
  accessAnticipationPaymentSlip: {
    id: 51,
    description: 'Financeiro: boletos para antecipação',
  },
  anticipationPaymentSlipDownload: {
    id: 52,
    description: 'Financeiro: boletos para antecipação - download',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
      'url',
    ],
  },
  anticipationPaymentSlipSolicitation: {
    id: 53,
    description: 'Financeiro: boletos para antecipação - solicitado',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  anticipationPaymentSlipSolicitationReady: {
    id: 54,
    description: 'Financeiro: boletos para antecipação - gerado',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  anticipationPaymentSlipSolicitationError: {
    id: 55,
    description: 'Financeiro: boletos para antecipação - erro',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  anticipationPaymentSlipSolicitationExpired: {
    id: 56,
    description: 'Financeiro: boletos para antecipação - expirado',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
    ],
  },
  anticipationPaymentSlipEmail: {
    id: 57,
    description: 'Financeiro: Antecipação - Email',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
      'url',
    ],
  },
  latePaymentSlipEmail: {
    id: 58,
    description: 'Financeiro: Atraso - Email',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
      'url',
    ],
  },
  toExpirePaymentSlipEmail: {
    id: 59,
    description: 'Financeiro: Boleto Próx Venc - Email',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
    ],
  },
  toExpirePaymentSlipHomeEmail: {
    id: 60,
    description: 'Financeiro: Boleto Próx Venc: Home - Email',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
    ],
  },
  anticipationPaymentSlipSms: {
    id: 61,
    description: 'Financeiro: Antecipação - SMS',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
      'url',
      'barcode',
      'userCellphone',
    ],
  },
  latePaymentSlipSms: {
    id: 62,
    description: 'Financeiro: Atraso - SMS',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'paymentTotal',
      'expirationDate',
      'solicitationCode',
      'parcels',
      'url',
      'barcode',
      'userCellphone',
    ],
  },
  toExpirePaymentSlipSms: {
    id: 63,
    description: 'Financeiro: Boleto Próx Venc - SMS',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
      'barcode',
      'userCellphone',
    ],
  },
  toExpirePaymentSlipSmsHome: {
    id: 64,
    description: 'Financeiro: Boleto Próx Venc: Home - SMS',
    details: [
      'contractId',
      'contractType',
      'detachedType',
      'serieId',
      'serieCode',
      'parcelCode',
      'discountedValue',
      'expirationDate',
      'url',
      'ready',
      'barcode',
      'userCellphone',
    ],
  },
  accessOwnerDocs: {
    id: 65,
    description: 'Documentos da Unidade - Doc Proprietario',
  },
  ownerDocsDownload: {
    id: 66,
    description: 'Documentos da Unidade - Doc Proprietario download',
    details: ['title', 'attachment'],
  },
  accessNewsAwards: {
    id: 67,
    description: 'Notícias - Prêmios',
  },
  accessNewsEngineering: {
    id: 68,
    description: 'Notícias - Engenharia',
  },
  accessNewsPressRoom: {
    id: 69,
    description: 'Notícias - Sala de Imprensa',
  },
  accessNewsHappen: {
    id: 70,
    description: 'Notícias - Aconteceu',
  },
  linkNewsHappen: {
    id: 71,
    description: 'Notícias - Aconteceu Video',
    details: ['title', 'attachment'],
  },
  discountList: {
    id: 72,
    description: 'Parcerias e Descontos',
  },
  discountLink: {
    id: 73,
    description: 'Parcerias e Descontos - Link',
  },
  accessBankFinancing: {
    id: 74,
    description: 'Financeiro: Financiamento Bancário',
  },
  keyDeliverySchedule: {
    id: 75,
    description: 'Entrega de Chaves - Agendamento',
    details: ['date', 'type', 'termsAgreed'],
  },
  keyDeliveryReschedule: {
    id: 76,
    description: 'Entrega de Chaves - Reagendamento',
    details: ['date'],
  },
  keyDeliveryCancel: {
    id: 77,
    description: 'Entrega de Chaves - Cancelamento',
    details: ['date'],
  },
  inspectionSchedule: {
    id: 78,
    description: 'Vistoria de obra - Agendamento',
  },
  inspectionReschedule: {
    id: 79,
    description: 'Vistoria de obra - Reagendamento',
  },
  technicalAssistanceSchedule: {
    id: 80,
    description: 'Assistência Técnica - Agendamento',
  },
  technicalAssistanceReschedule: {
    id: 81,
    description: 'Assistência Técnica - Reagendamento',
  },
  technicalAssistanceCancellation: {
    id: 82,
    description: 'Assistência Técnica - Cancelamento',
  },
  changeRepeatedEmail: {
    id: 83,
    description: 'Alterou e-mail repetido',
  },
  accessChangeRepeatedEmail: {
    id: 84,
    description: 'Alterar email repetido',
  },
  segmentedHome: {
    id: 85,
    description: 'Home Segmentada',
    details: ['Home Segmentada'],
  },
  accessRepeatedEmail: {
    id: 86,
    description: 'Acesso: Email Repetido',
  },
  accessKeyDeliverySchedule: {
    id: 87,
    description: 'Acesso: Entrega de Chaves',
  },
  accessAppointments: {
    id: 88,
    description: 'Acesso: Meus Compromissos',
  },
  accessInspectionDetails: {
    id: 89,
    description: 'Acesso: Vistoria de Obra',
  },
  accessSyndicSelectProduct: {
    id: 90,
    description: 'Acesso: Seleção de Unidades - Síndico',
  },
  accessAppointmentDetail: {
    id: 91,
    description: 'Acesso: Detalhes do Agendamento',
  },
  accessProfilePassword: {
    id: 92,
    description: 'Acesso: Cadastro: Alterar Senha',
  },
  connectionError: {
    id: 93,
    description: 'Erro de conexão',
  },
  controlledLogError: {
    id: 94,
    description: 'Log Controlado: Erro',
    details: ['Errors'],
  },
  controlledLogInfo: {
    id: 95,
    description: 'Log Controlado: Informação',
    details: ['Information'],
  },
  accessNewsIframe: {
    id: 96,
    description: 'Acesso: Notícias - Iframe',
    details: ['type'],
  },
  accessCredits: {
    id: 97,
    description: 'Acesso: Créditos',
  },
  imageStockLink: {
    id: 98,
    description: 'Link - Image Stock',
    details: ['title', 'url'],
  },
  undefinedLog: {
    id: 9999,
    description: 'Log não cadastrado',
  },
  acceptedPrivacyPolity: {
    id: 100,
    description: 'Política de Privacidade Aceita',
    details: ['version'],
  },
  acceptedPopup: {
    id: 101,
    description: 'Pop-up informativo de segurança: Aceite do cliente',
    details: ['id', 'title', 'description'],
  },
  dontShowPopupAgain: {
    id: 102,
    description:
      'Pop-up informativo de segurança: Não exibir novamente essa mensagem',
    details: ['id', 'title', 'description'],
  },
};

const routes = {
  home: actions.accessHome,
  myDecorated: actions.accessMyDecorated,
  constructionProgress: actions.accessConstructionProgress,
  toExpirePaymentSlip: actions.accessToExpirePaymentSlip,
  latePaymentSlip: actions.accessLatePaymentSlip,
  incomeReport: actions.accessFinancialIR,
  financialPosition: actions.accessFinancialPosition,
  legalDocuments: actions.accessLegalDocs,
  generalDocuments: actions.accessGeneralDocs,
  bulletins: actions.accessBulletins,
  ticketForm: actions.accessTicketNew,
  ticketList: actions.accessTicketList,
  faq: actions.accessFaq,
  profile: actions.accessProfile,
  profilePassword: actions.accessProfilePassword,
  myEnterprise: actions.accessMyEnterprise,
  selectUnit: actions.accessSelectUnit,
  ombudsmanForm: actions.accessTicketOmbudsman,
  anticipationPaymentSlip: actions.accessAnticipationPaymentSlip,
  ownerDocuments: actions.accessOwnerDocs,
  newsAwards: actions.accessNewsAwards,
  newsEngineering: actions.accessNewsEngineering,
  newsHappen: actions.accessNewsHappen,
  newsPressRoom: actions.accessNewsPressRoom,
  discountList: actions.discountList,
  bankFinancing: actions.accessBankFinancing,
  changeRepeatedEmail: actions.accessRepeatedEmail,
  keyDeliverySchedule: actions.accessKeyDeliverySchedule,
  appointments: actions.accessAppointments,
  inspectionDetails: actions.accessInspectionDetails,
  syndicSelectProduct: actions.accessSyndicSelectProduct,
  appointmentDetail: actions.accessAppointmentDetail,
  ticketDetails: actions.accessTicketDetails,
  newsIframe: actions.accessNewsIframe,
  credits: actions.accessCredits,
  acceptedPolity: actions.acceptedPrivacyPolity,
  acceptedPopup: actions.acceptedPopup,
  dontShowPopupAgain: actions.dontShowPopupAgain,
};

export default {
  actions,
  routes,
};



// WEBPACK FOOTER //
// ./src/utils/logTraceEnums.js